module.exports = __webpack_public_path__ + "img/fo.3fe6f65b.svg";